export class PayableRequest {
    invoiceId:number
    invoiceType:string
    quantity:number
    amount:number
    deduction:number
    finalAmount:number
    payment:number
    createdUser:string
    vendorId:number
    receivedDate:string|Date
    invoiceNumber:string
    item:string
    tdsApplicable:boolean
    due:number
    invoiceDate:string|Date

    constructor(
        invoiceId:number,
    invoiceType:string,
    quantity:number,
    amount:number,
    deduction:number,
    finalAmount:number,
    payment:number,
    createdUser:string,
    vendorId:number,
    receivedDate:Date,
    invoiceNumber:string,
    item:string,
    tdsApplicable:boolean,
     due:number,
     invoiceDate:Date
    ){
        this.amount =amount
        this.createdUser = createdUser
        this.deduction =deduction 
        this.finalAmount = finalAmount
        this.invoiceId = invoiceId
        this.invoiceType = invoiceType
        this.vendorId = vendorId
        this.receivedDate = receivedDate
        this.payment = payment
        this.quantity = quantity
        this.invoiceNumber = invoiceNumber
        this.item = item
        this.tdsApplicable = tdsApplicable
        this.due = due
        this.invoiceDate = invoiceDate
    }
}
export class PayableFilterRequest{
    type?:string
    invoiceNumber?:string
    invoiceFromDate?:string
    invoiceToDate?:string
    receivedFromDate?:string
    receivedToDate?:string
    supplierId?:number
    unit?:string
    constructor(
        type?:string,
    invoiceNumber?:string,
   invoiceFromDate?:string,
    invoiceToDate?:string,
    receivedFromDate?:string,
    receivedToDate?:string,
    supplierId?:number,
    unit?:string
    )
{
    this.invoiceFromDate = invoiceFromDate
    this.invoiceNumber = invoiceNumber
    this.receivedFromDate = receivedFromDate
    this.supplierId= supplierId
    this.type = type =type
    this.invoiceToDate = invoiceToDate
    this.receivedToDate = receivedToDate
    this.unit= unit

}
}